export const getReviewMicrodata = (
  user_name,
  datePublished,
  rating,
  text) => {
  return {
    '@type': 'Review',
    'author': {
      '@type': 'Person',
      'name': user_name
    },
    'datePublished': datePublished,
    'reviewRating': rating && rating !== '0' ? {
      '@type': 'Rating',
      'ratingValue': rating,
      'bestRating': '5'
    } : undefined,
    'reviewBody': text
  }
}
